const STORAGE_KEY = 'brs-zoom-embed'

const DEFAULT_SIZE = {
  width: 400,
  height: 300
}

const MIN_SIZE = {
  width: 280,
  height: 200
}

function clampSize (value, min, max) {
  const parsed = Number(value)
  if (!Number.isFinite(parsed)) return min
  let result = Math.max(min, Math.round(parsed))
  if (Number.isFinite(max)) {
    result = Math.min(result, max)
  }
  return result
}

export function getZoomEmbedPreferences () {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return {
        isExpanded: false,
        width: DEFAULT_SIZE.width,
        height: DEFAULT_SIZE.height
      }
    }

    const parsed = JSON.parse(raw)
    return {
      isExpanded: Boolean(parsed.isExpanded),
      width: clampSize(parsed.width, MIN_SIZE.width),
      height: clampSize(parsed.height, MIN_SIZE.height)
    }
  } catch {
    return {
      isExpanded: false,
      width: DEFAULT_SIZE.width,
      height: DEFAULT_SIZE.height
    }
  }
}

export function saveZoomEmbedPreferences ({ isExpanded, width, height }) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({
    isExpanded: Boolean(isExpanded),
    width: clampSize(width, MIN_SIZE.width),
    height: clampSize(height, MIN_SIZE.height)
  }))
}

export function clampZoomSize (width, height, maxWidth, maxHeight) {
  return {
    width: clampSize(width, MIN_SIZE.width, maxWidth),
    height: clampSize(height, MIN_SIZE.height, maxHeight)
  }
}

export { DEFAULT_SIZE, MIN_SIZE }
